module.exports = __webpack_public_path__ + "img/art_5_4.1810cf03.jpg";